import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/components/ui/tabs';
import { GoalCategoriesTab } from './GoalCategoriesTab';
import { GoalAutomationTab } from './GoalAutomationTab';

const SUB_TABS = [
  { key: 'categories', label: 'Categories' },
  { key: 'automation', label: 'Automation' },
];

/**
 * Module-scoped config for Goals. Both panels sit behind the single `goals.config`
 * permission, so they are sub-tabs of one Config tab rather than two top-level tabs —
 * the top row stays audience-oriented (My / Team / Reviews / Config).
 */
export function GoalConfigTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('sub');
  const active = SUB_TABS.some((t) => t.key === requested) ? requested! : 'categories';

  function setSub(key: string) {
    const next = new URLSearchParams(searchParams);
    next.set('sub', key);
    setSearchParams(next, { replace: true });
  }

  return (
    <div className="space-y-4">
      <Tabs tabs={SUB_TABS} active={active} onChange={setSub} className="max-w-xs" />
      {active === 'categories' ? <GoalCategoriesTab /> : <GoalAutomationTab />}
    </div>
  );
}
